export default {
  nullValue: 'Brak danych',
};
